/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { YospaceAdsSession } from './YospaceAdsSession';
import { YospacePlayer } from './internal/YospacePlayer';
import { Logger } from '@quickplay/foundation';

export class YospaceAdsPlayerFactory {
  static createYospaceAdsPlayer(player: any, yospaceSession: YospaceAdsSession, yospaceSDK: any, logger?: Logger): any {
    return new YospacePlayer(player, yospaceSession, yospaceSDK, logger);
  }
}
